import {Component, Inject, OnInit} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from "@angular/material/dialog";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {CatalogResource, CatalogsService} from "../../core/modules/openapi";
import {
  ApplicationCriteriaData,
  ApplicationsSearchComponent
} from "../applications-search/applications-search.component";
import {MatFormField, MatInput} from "@angular/material/input";
import {MatChipListbox, MatChipOption} from "@angular/material/chips";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatButton} from "@angular/material/button";
import {CommonService} from "../../services/common.service";

enum FilterType {
  StatusFilter,
  InsurerFilter,
  InsurableInterestIdentifierFilter
}

interface StatusFilter {
  name: "Estado",
  value: StatusEnum[]
}

interface InsurerFilter {
  name: "Aseguradora",
  value: string[]
}

interface InsurableInterestIdentifierFilter {
  name: "Placa",
  value: string
}

export enum StatusEnum {
  NEW = "Nueva",
  IN_PROGRESS = "En Progreso",
  IN_VALIDATION = "En Validación",
  VALIDATION_ERROR = "Error de Validación",
  IN_ISSUING = "En Emisión",
  ISSUING_ERROR = "Error de Emisión",
  IN_PRINTING = "En Impresión",
  PRINTING_ERROR = "Error de Impresión",
  DONE = "Emitida",
  REJECTED = "Rechazada"
}

export const statusEnumLookup: { [key: string]: StatusEnum } = {
  NEW: StatusEnum.NEW,
  IN_PROGRESS: StatusEnum.IN_PROGRESS,
  IN_VALIDATION: StatusEnum.IN_VALIDATION,
  VALIDATION_ERROR: StatusEnum.VALIDATION_ERROR,
  IN_ISSUING: StatusEnum.IN_ISSUING,
  ISSUING_ERROR: StatusEnum.ISSUING_ERROR,
  IN_PRINTING: StatusEnum.IN_PRINTING,
  PRINTING_ERROR: StatusEnum.PRINTING_ERROR,
  DONE: StatusEnum.DONE,
  REJECTED: StatusEnum.REJECTED,
};

@Component({
  selector: 'app-applications-criteria',
  imports: [
    MatDialogContent,
    MatFormField,
    MatDialogActions,
    MatChipListbox,
    MatChipOption,
    MatFormFieldModule,
    MatInput,
    FormsModule,
    ReactiveFormsModule,
    MatDialogTitle,
    MatButton
  ],
  templateUrl: './applications-criteria.component.html',
  standalone: true,
  styleUrl: './applications-criteria.component.sass'
})
export class ApplicationsCriteriaComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ApplicationsSearchComponent>, @Inject(MAT_DIALOG_DATA) public data: ApplicationCriteriaData,
    private readonly formBuilder: FormBuilder, private readonly commonService: CommonService
  ) {
  }

  form: FormGroup;
  insurers: CatalogResource[];
  statusList: [string, StatusEnum][] = Object.entries(StatusEnum);
  selectedInsurers: any;
  selectedStatus: [string, StatusEnum][];

  compareStatus(o1: [string, StatusEnum], o2: [string, StatusEnum]): boolean {
    return o1 && o2 ? o1[0] === o2[0] : o1 === o2;
  }

  compareInsurer(o1: CatalogResource, o2: CatalogResource): boolean {
    return o1 && o2 ? o1.code === o2.code : o1 === o2;
  }

  ngOnInit() {
    this.commonService.getInsurers().subscribe(insurers => {
      if (insurers) this.insurers = insurers;
    });
    this.form = this.formBuilder.group({
      insurableInterestIdentifier: [this.data?.insurableInterestIdentifier, [Validators.minLength(3), Validators.maxLength(10)]],
      insuredId: [this.data?.insuredId, [Validators.minLength(5), Validators.maxLength(15)]]
    });
    this.selectedInsurers = this.data?.insurerId;
    this.selectedStatus = this.data?.status;
  }

  onNoClick(): void {
    this.dialogRef.close({
      "action": "CANCEL"
    });
  }

  createClick(): void {
    this.form.controls['insurableInterestIdentifier'].markAsTouched();
    this.form.controls['insuredId'].markAsTouched();
    if (this.form.valid) {
      this.dialogRef.close({
        "action": "SET",
        ...this.form.value,
        "insurerId": this.selectedInsurers,
        "status": this.selectedStatus
      });
    }
  }
}
